import { createFileRoute } from '@tanstack/react-router'
import { StaffKeuangan } from '../../../../components/StaffKeuangan'

export const Route = createFileRoute('/desa/$slug/dashboard/keuangan')({
  component: () => {
    const { slug } = Route.useParams()
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffKeuangan desaId={desaId} slug={slug} />
  },
})
